import React, { Component } from 'react';

import { APIHandler, ShowcaseCountry, ContentHeader, BackImage, BackButton } from 'C4';
import PropTypes from 'prop-types';
import Breadcrumbs from 'react-router-dynamic-breadcrumbs';

const crumbRoutes = {
  '/main': 'Home',
  '/main/sell': 'Sell',
  '/main/sell/videos': 'Videos',
};
export default class ShowcaseCollectionView extends Component {
  constructor(props) {
    super(props);
    this.state = {
      header: [],
      stands: [],
      id: '',
      loading: true,
    };
  }

  componentWillMount() {
    this.getStandsAndFloor();
  }

  getStandsAndFloor() {
    const { category } = this.props.match.params;
    APIHandler.getExhibitionStandsByCategory(category, 715).then((res) => {
      this.setState({ stands: res[0].tiles_sorted, header: res[0], id: res[0].id, loading: false });
    });
  }

  render() {
    const { header, stands, id, loading } = this.state;
    const { category } = this.props.match.params;
    const params = new URLSearchParams(window.location.search);

    let icon = '';
    if (header.icon) {
      icon = header.icon.replace('fa-', '');
    }

    if (stands.length === 0 && loading) {
      return <div />;
    }

    if (stands.length === 0 && !loading) {
      return <div className="showcaseCollectionViewContainer"><div className="no__spotlights">Check back soon for new spotlights in {category.replace(/-/g, ' ').replace('middle east', 'the middle east')}</div></div>;
    }

    let countries = [];
    if (stands.length !== 0) {
      countries = [...new Set(stands.map(stand => stand.country))];
    }

    return (
      <div className="showcaseCollectionViewContainer">
        <BackImage />
        <div className="showcaseContainer">
          {params.get('header') === 'false' && (
            <BackButton
              to="/"
              text="Back"
            />
          )}
          {header.title && <ContentHeader header={header.title} icon={icon} />}
          <Breadcrumbs
            mappedRoutes={crumbRoutes}
            WrapperComponent={props => <ul className="breadcrumb__List">{props.children}</ul>}
            LinkComponent={props => <li className="breadcrumb__item">{props.children}<span className="breadcrumb__separator">&#62;</span></li>}
            ActiveLinkComponent={props => <li className="breadcrumb__item--active">{props.children}</li>}
          />
          <div className="showcaseCountriesGrid">
            {countries.map(country => (
              <ShowcaseCountry
                category={category}
                country={country}
                key={country}
                id={id}
              />
            ))}
          </div>
        </div>
        {params.get('header') === 'false' && (
          <style>
            {
              "\
        .header { display: none; } .showcaseContainer { margin-top: 3rem !important; }"
            }
          </style>
        )}
      </div>
    );
  }
}

ShowcaseCollectionView.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape().isRequired,
    url: PropTypes.string.isRequired,
  }).isRequired,
};

ShowcaseCollectionView.defaultProps = {
  // headerSubtitle: '',
};
